import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui/next';

import { useCTASection } from './hooks/useCTASection';

export function CTASection() {
	const {
		data: {
			ctaSection: { title, ctaText, image },
		},
	} = useCTASection();

	return (
		<HeroLayout media={<Image src={image.src} className="h-full w-full object-cover" alt={image.alt} />}>
			<div className="bg-gradient-background-dark-3 flex h-full flex-col justify-center gap-6 p-6 md:p-12">
				<Text variant="heading" className="text-typography-inverse-strong max-w-[600px]">
					{title}
				</Text>
				<div className="flex w-full gap-4 max-lg:flex-col">
					<Button
						variant="primary"
						data-qa="footer-sap-button"
						size="large"
						className="max-w-none max-lg:w-full"
						as="a"
						href="/start-a-petition?source_location=petition_guides"
					>
						{ctaText}
					</Button>
				</div>
			</div>
		</HeroLayout>
	);
}
